export const mysteryShopperColors = {
  green: '#4CBF8F',
  red: '#FF6666',
  orange: '#FFAC30',
};
